import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appDatatableCellAnchor]',
})
export class DatatableCellAnchorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
